<template>
  <div class="rich-text-main">
    <editor
      v-if="visible"
      v-model="content"
      ref="editor"
      :init="{
        ...init,
        content_style: `body { color: ${personInfo.theme === 'dark' ? '#fff' : '#1F232A'}; padding-left: 16px !important; padding-right: 16px !important; }`,
        placeholder,
      }"
      v-bind="$attrs"
      v-on="$listeners"
      @input="contentChange"
    >
    </editor>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists'; // 列表插件
import 'tinymce/plugins/link';
import 'tinymce/icons/default';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/autoresize';

export default {
  name: 'EditorRichText',
  props: {
    baseUrl: {
      type: String,
      default: process.env.NODE_ENV === 'development' ? '' : process.env.OSS,
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      content: this.description,
      listenerDom: null,
      visible: true,
      init: {
        language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
        language: 'zh_CN',
        skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
        content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
        autoresize_min_height: 187,
        autoresize_max_height: 393,
        plugins: 'lists link paste autoresize',
        toolbar: 'undo redo bold italic bullist numlist outdent indent link removeformat',
        toolbar_sticky: true,
        branding: false,
        menubar: false,
        paste_remove_styles_if_webkit: true,
        paste_remove_styles: true,
        contextmenu: false,
        paste_as_text: true,
        paste_word_valid_elements: 'b,strong,em,li,ul,ol,p',
        placeholder: '',
        content_style: `body { color: ${this.$store.state.theme === 'dark' ? '#fff' : '#1F232A'};padding-left: 16px; padding-right: 16px; }`,
        setup: (editor) => {
          editor.on('focus', () => {
            this.$emit('editorFocus');
          });
        },
      },
    };
  },
  watch: {
    'personInfo.theme': {
      handler(newVal) {
        const iframes = document.querySelectorAll('.tox-edit-area__iframe');
        iframes.forEach((item) => {
          const iframeDoc = item.contentDocument || item.contentWindow.document;
          iframeDoc.body.style.color = newVal === 'dark' ? '#fff' : '#1F232A';
        });
      },
    },
    description(newVal) {
      this.content = newVal;
    },
  },
  computed: {
    ...mapState('me', ['personInfo']),
  },
  components: {
    Editor,
  },
  methods: {
    contentChange() {
      this.$emit('contentChange', this.content);
    },
    initTinymceEditor() {
      // 拖拽排序的时候，tinymce会显示空白且无法选中，无报错提示，重置显示可以暂时解决。
      this.visible = false;
      let timer = setTimeout(() => {
        this.visible = true;
        clearTimeout(timer);
      }, 0);
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/css/variable.scss';
.rich-text-main {
  min-height: 187px;
  max-height: 393px;
  .tox-statusbar {
    display: none;
  }
  ::v-deep(.tox-tinymce) {
    border-radius: 12px;
    min-height: 187px;
    max-height: 393px;
    border: 1px solid transparent !important;
    .tox-editor-header {
      .tox-toolbar-overlord {
        background-color: $editor-header-bg-color;
        .tox-toolbar__primary {
          background-color: $editor-header-bg-color !important;
          .tox-toolbar__group {
            .tox-tbtn {
              color: $editor-header-tool-color;
              svg {
                fill: $editor-header-tool-color;
              }
              &:hover {
                background: $editor-header-tool-hover-color;
              }
              &.tox-tbtn--enabled {
                background: $editor-header-tool-active-color;
              }
            }
          }
        }
      }
    }
    .tox-sidebar-wrap {
      .tox-edit-area {
        .tox-edit-area__iframe {
          background-color: $editor-iframe-bg-color;
          body {
            color: $text-color;
          }
        }
      }
    }
  }
  ::v-deep {
    .tox-editor-container.auto {
      padding-top: 0 !important;
    }
    .tox-editor-header.auto {
      position: static !important;
      width: auto !important;
      box-shadow: none !important;
    }
  }
}
</style>
